/** The only dyeing station the Batch flow runs on today. */
export const DYEING_STATION_ASSET_ID = 'DM-1';

export interface ProductionCardDyeingCycle {
  id: string;
  number: string;
  productionCardReference: string;
  cycleNumber: number;
  startTime: Date;
  endTime?: Date;
  removedTime?: Date;
  itemConsumptions?: ItemConsumption[];
  waterUsageInLiters?: number;
  estimatedWaterUsageInLiters?: number;
  consumptionsFinalized: boolean;
  dyedBundleReferences: DyedBundleReferenceRollNumberKey[];
  colorStatusApproval?: ColorStatusApproval;
  startStationAssetId?: string;
  endStationAssetId?: string;
  isFirstRun: boolean;
  createdBy?: string;
  createdDate?: Date;
  modifiedBy?: string;
  modifiedDate?: Date;
}

export interface ItemConsumption {
  itemCode: string;
  quantity: number;
  estimatedQuantity?: number;
  uom: number;
}

export interface DyedBundleReferenceRollNumberKey {
  productionCardBundleReferences: string;
  rollNumbers: string[];
  weightInLbs: number;
}

export interface ColorStatusApproval {
  userName: string;
  approvalDate: Date;
  isApproved: boolean;
  comments?: string;
  isHardStop?: boolean;
}
